var map = {
	"./10c.png": 2821,
	"./10d.png": 6042,
	"./10h.png": 1958,
	"./10s.png": 2901,
	"./2c.png": 1938,
	"./2d.png": 3501,
	"./2h.png": 4305,
	"./2s.png": 5154,
	"./3c.png": 8837,
	"./3d.png": 4170,
	"./3h.png": 3350,
	"./3s.png": 7205,
	"./4c.png": 584,
	"./4d.png": 199,
	"./4h.png": 7179,
	"./4s.png": 8024,
	"./5c.png": 5219,
	"./5d.png": 7820,
	"./5h.png": 5392,
	"./5s.png": 4147,
	"./6c.png": 6278,
	"./6d.png": 9353,
	"./6h.png": 1765,
	"./6s.png": 6310,
	"./7c.png": 6102,
	"./7d.png": 3894,
	"./7h.png": 5658,
	"./7s.png": 6937,
	"./8c.png": 9548,
	"./8d.png": 4419,
	"./8h.png": 3615,
	"./8s.png": 3804,
	"./9c.png": 9863,
	"./9d.png": 4696,
	"./9h.png": 7684,
	"./9s.png": 5239,
	"./ac.png": 8095,
	"./ad.png": 9440,
	"./ah.png": 8236,
	"./as.png": 8047,
	"./jc.png": 250,
	"./jd.png": 2309,
	"./jh.png": 7689,
	"./js.png": 9274,
	"./kc.png": 1693,
	"./kd.png": 6834,
	"./kh.png": 1934,
	"./ks.png": 7949,
	"./qc.png": 1039,
	"./qd.png": 5664,
	"./qh.png": 4444,
	"./qs.png": 7407
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6008;